import React, { useEffect, useState } from 'react';
import { Grid, makeStyles, Typography, Box, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from 'react-redux';
import { ToolKit } from '../../components';
import rou from '../../router';
import { i18n } from '../../language';
import { authNameE } from '../../utils/userFuncs';
import ehandoverIds from '../../ids/Ehandover';
import { goToWardDrivePage } from '../../utils/wardDrive';
import { userRoleList, userRoleFunc } from '../../utils/userRole';
import { hospitalWardListFunc } from '../../utils/hospitalWardList';
import { CUBICLE_VIEW, CUBICLE_VIEW2 } from '../../redux/constant';

const useStyle = makeStyles((theme) => ({
  root: {
    padding: '2.188rem 22.838rem 2.188rem 3.438rem',
    background: theme.palette.bodyBG,
    position: 'relative',
    minHeight: '100vh',
  },
  h1: {
    fontSize: '2.25rem',
    lineHeight: '3rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    fontFamily: 'NotoSans-Bold',
  },
  h2: {
    fontSize: '1.5rem',
    lineHeight: '2.3rem',
    color: '#7d86a9',
    marginTop: '0.625rem',
  },
  h3: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    marginTop: '2.5rem',
  },
  warningBox: {
    position: 'fixed',
    top: '80px',
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1000,
  },
  warningContent: {
    width: '100%',
    maxWidth: '680px',
    padding: '1.75rem 2rem',
    backgroundColor: '#FF655C',
    border: '1px solid #ffb74d',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'white',
    boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.25)',
    fontSize: '16px',
    fontFamily: 'Noto Sans',
    fontWeight: '500',
    wordWrap: 'break-word',
  },
  closeButton: {
    padding: '4px',
    color: 'white',
  },
}));

export default function PageHome(props) {
  const classes = useStyle();
  const loginInfo = useSelector((state) => state.loginInfo);
  const roleMap = useSelector((state) => state.roleMap);
  const { defaultViewType } = useSelector((state) => state.bedStatusView);

  const hospitalWardList = useSelector((state) => state.hospitalWardList);
  const userRole = useSelector((state) => state.userRole);
  const wardInfo = useSelector((state) => state.wardInfo);

  let hospWard = {};
  if (loginInfo.flag) {
    hospWard = userRoleList.getDetailFormat(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId);
  } else {
    hospWard = hospitalWardListFunc.getDetailFormat(hospitalWardList, wardInfo.hospitalId, wardInfo.wardId);
  }

  const wardName = hospWard.wardName ? hospWard.wardName : undefined;
  const hospName = hospWard.hospitalName ?? '';

  return (
    <div className={classes.root}>
      <Typography variant="h4" component="h2" className={classes.h1}>
        {wardName ? i18n.t('HOME_TITLE', { value: wardName }) : i18n.t('HOME_WELCOME')}
      </Typography>
      <Typography component="h2" className={classes.h2}>
        {hospName}
      </Typography>
      {!roleMap && (roleMap[authNameE.eHandover] || roleMap[authNameE.bedStatus] || roleMap[authNameE.dutyAssign]) ? (
        <Typography className={classes.h3}>{i18n.t('HOME_TOOLKIT')}</Typography>
      ) : (
        ''
      )}
      {/* <OperrationAlert /> */}
      <Grid container xs={12} spacing={2} item>
        {Boolean(!roleMap || roleMap[authNameE.eHandover]) && (
          <ToolKit
            text={i18n.t('NAV_EHANDOVER')}
            onClick={() => {
              props.history.push(rou.ehandoverRou.path);
            }}
            id={ehandoverIds.ehandover_btn}
          />
        )}
        {Boolean(!roleMap || roleMap[authNameE.bedStatus]) && (
          <ToolKit
            text={i18n.t('NAV_BED_STATUS')}
            onClick={() => {
              props.history.push(
                [CUBICLE_VIEW, CUBICLE_VIEW2]?.includes(defaultViewType)
                  ? rou.bedstatusNewRou.path
                  : rou.bedstatusRou.path
              );
            }}
            id="bedStatus_btn"
          />
        )}
        {Boolean(!roleMap || roleMap[authNameE.dutyAssign]) && (
          <ToolKit
            text={i18n.t('NAV_DUTY_ASSIGN')}
            onClick={() => {
              props.history.push(rou.dutyassignRou.path);
            }}
            id="dutyassign_btn"
          />
        )}
        {Boolean(!roleMap || roleMap[authNameE.equipment]) && (
          <ToolKit
            text={i18n.t('NAV_EQUIPMENT')}
            onClick={() => {
              props.history.push(rou.equipmentRou.path);
            }}
            id="equipment_btn"
          />
        )}
        {Boolean(!roleMap || roleMap[authNameE.televisit]) && (
          <ToolKit
            text={i18n.t('NAV_TELEVISIT')}
            onClick={() => {
              props.history.push(rou.televisitRou.path);
            }}
            id="televisit_btn"
          />
        )}
        {Boolean(!roleMap || roleMap[authNameE.wardDrive]) && (
          <ToolKit
            text={i18n.t('NAV_WARD_DRIVE')}
            onClick={() => {
              goToWardDrivePage();
            }}
            id="warddrive_btn"
          />
        )}
        {/*  logout的状态也需要能看到admission */}
        {Boolean(
          !roleMap || (roleMap[authNameE.admission] && (userRoleFunc?.getIsShowAdmission() || !loginInfo?.flag))
        ) && (
          <ToolKit
            text={i18n.t('NAV_ADMISSION')}
            onClick={() => {
              props.history.push(rou.admissionRou.path);
            }}
            id="admission_btn"
          />
        )}
        {Boolean(!roleMap || roleMap[authNameE.patient_survey]) && (
          <ToolKit
            text="Patient Appreciation"
            onClick={() => {
              props.history.push(rou.patientSurveyRou.path);
            }}
            id="patient_btn"
          />
        )}
      </Grid>
      {/* <Notification context={NotficList} /> */}
    </div>
  );
}
